import { useState } from 'react';
import { AiOutlineClose } from 'react-icons/ai';
import { BsFillShareFill, BsTwitterX } from 'react-icons/bs';
import { EmailIcon, EmailShareButton, FacebookIcon, FacebookShareButton, LineIcon, LineShareButton, TwitterShareButton } from 'react-share';
import { APP_URL } from 'src/constants';
import { sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';
import styled from 'styled-components';
import Image from '../image';

const WidgetShareSticky = ({ article, link, eventDataLayer }: any) => {
  const [isShare, setIsShare] = useState(false);

  const shareLink = `${APP_URL}${link}`;
  const SOCIAL_SHARE = [
    {
      id: 1,
      name: 'facebook',
      icon: (
        <FacebookShareButton url={shareLink}>
          <FacebookIcon size={36} round={true} />
        </FacebookShareButton>
      )
    },
    {
      id: 2,
      name: 'X',
      icon: (
        <TwitterShareButton url={shareLink}>
          <div className='x-sticky-wrapper'>
            <BsTwitterX />
          </div>
        </TwitterShareButton>
      )
    },
    {
      id: 3,
      name: 'line',
      icon: (
        <LineShareButton url={shareLink}>
          <LineIcon size={36} round={true} />
        </LineShareButton>
      )
    },
    {
      id: 4,
      name: 'email',
      icon: (
        <EmailShareButton url={shareLink}>
          <EmailIcon size={36} round={true} />
        </EmailShareButton>
      )
    }
  ];
  return (
    <WidgetWrapper>
      <BsFillShareFill color='#ED1A3B' onClick={() => setIsShare(!isShare)} />
      {isShare && (
        <div className='share-popup'>
          <div className='share-detail'>
            <div className='share bar'>
              <label>แชร์</label>
              <AiOutlineClose color='#ED1A3B' className='close' onClick={() => setIsShare(!isShare)} />
            </div>
            <div className='share header'>
              <div className='share header-title'>
                <label className='share header-attribution'>The People</label>
                <label className='share header-abstract'>{article?.title}</label>
              </div>
              <div className='share header-image'>
                <Image image={article?.image} title={article?.title} decorative={false} />
              </div>
            </div>
          </div>
          <div className='share grid'>
            {SOCIAL_SHARE.map((item, index) => (
              <div className='share item'>
                <div
                  key={index}
                  className={`--${item.name}`}
                  // ! DATALAYER
                  onClick={() =>
                    sendDataLayerGlobal({
                      ...eventDataLayer,
                      data: {
                        ...eventDataLayer.data,
                        title: item.name,
                        index: index + 1
                      }
                    })
                  }
                >
                  {item.icon}
                </div>
                <label>{item.name}</label>
              </div>
            ))}
          </div>
        </div>
      )}
    </WidgetWrapper>
  );
};

export default WidgetShareSticky;

const WidgetWrapper = styled.div`
  position: relative;
  text-align: center;
  background-color: #fff;
  padding: 10px 0;
  width: 100%;
  max-width: 50px;
  opacity: 1;
  transition: all 0.3s ease-in-out;
  svg {
    cursor: pointer;

    font-size: 26px;
    @media (max-width: 768px) {
      font-size: 20px;
    }
  }
  .disable-button {
    pointer-events: none;
  }
  .share-popup {
    // set style for popup
    position: absolute;
    background: white;
    border-radius: 5px;
    box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 21.38px, rgba(0, 0, 0, 0.19) 0px 32px 64px;
    opacity: 1;
    width: 352px;
    max-width: 352px;
    max-height: calc(100vh - 216px);
    min-height: 120px;
    top: 60px;
    right: 0;
    transition: all 0.4s ease 0s;
    @media (max-width: 768px) {
      right: 50px;
      left: unset;
      width: 280px;
      max-width: 280px;
      top: 5px;
    }
    &::before {
      content: '';
      position: absolute;
      top: -10px; /* Adjust this value as needed */
      right: 0; /* Adjust this value as needed */
      width: 0;
      height: 0;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 10px solid #fff;
      border-top: unset;
      @media (max-width: 768px) {
        top: 10px;
        right: -10px;
        left: unset;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 12.5px 0 12.5px 20px;
        border-top: 10px solid transparent;
        border-bottom: 10px solid transparent;
        border-right: unset;
        border-left: 10px solid #fff;
        border-color: transparent transparent transparent #fff;
      }
    }
    .close {
      position: absolute;
      top: 5px;
      right: 10px;
      padding: 5px;
      cursor: pointer;
    }

    .share-detail {
      padding: 15px;
      border-bottom: 1px solid #b3b3b3;
      .share.bar {
        display: flex;
        justify-content: space-between;
        .close {
          @media (max-width: 768px) {
            font-size: 28px;
          }
        }
      }
      .share.header {
        display: flex;
        justify-content: space-evenly;
        margin-top: 4px;
        .share.header-title {
          display: flex;
          flex-direction: column;
          flex-grow: 1;
          margin-right: 12px;
        }
        .share.header-attribution {
          font-size: 12px;
          font-weight: 400;
          color: rgb(95, 95, 95);
          text-align: left;
        }
        .share.header-abstract {
          font-size: 14px;
          font-weight: 600;
          margin-top: 4px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          text-align: left;
        }
        .share.header-image {
          width: 76px;
          flex-shrink: 0;
          .resolution-image {
            padding-top: unset !important;
            height: 100%;
          }
          img {
            /* img { */
            border-radius: 4px;
            width: 76px;
            height: 76px;
            object-fit: cover;
            /* } */
          }
        }
      }
    }
  }
  .share.grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
  .share.item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 96px;
    gap: 4px;
    .--X button {
      display: flex;
      align-items: start;
      height: 43px;
    }
  }
  .share.item label {
    font-size: 12px;
    font-weight: 400;
    white-space: nowrap;
  }
  .x-sticky-wrapper {
    width: 36px;
    height: 36px;
    background-color: #000;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    svg {
      color: #fff;
      font-size: 18px;
    }
  }
`;
